import React from 'react';
import liveAgentImg from '../assets/live_agent.png';

// Top bar showing the chat label and the live-agent action button.
function ChatHeader({
  dlFailed,
  isLiveMode,
  dlExiting,
  dlOnline,
  userNameLoading,
  isLiveAgentActive,
  showLiveAgentLabel,
  onRetry,
  onExit,
  onConnect,
}) {
  const avatar = <img src={liveAgentImg} alt="Support Agent" className="live-avatar" />;

  let action = null;
  if (dlFailed) {
    action = <button className="switch-live-btn" onClick={onRetry}>{avatar}Switch to Live Chat</button>;
  } else if (isLiveMode) {
    action = (
      <button className="switch-live-btn" onClick={onExit} disabled={dlExiting}>
        {avatar}
        {dlExiting ? 'Exiting…' : 'Exit Chat'}
      </button>
    );
  } else if (!isLiveAgentActive) {
    action = (
      <button className="switch-live-btn" onClick={onConnect} disabled={!dlOnline || userNameLoading}>
        {avatar}
        Switch to Live Chat
      </button>
    );
  }

  return (
    <header className="header">
      <span className="header-label">
        {dlFailed ? (
          <strong>Connection failed!</strong>
        ) : (
          <>You are chatting with <strong>{showLiveAgentLabel ? 'Live Agent' : 'AI Agent'}</strong></>
        )}
      </span>
      {action}
    </header>
  );
}

export default ChatHeader;
